import StorageService from './storageService'

export const USER_AUTHENTICATED = 'everlink_user'
export const USER_TYPE = 'everlink_type'

export default class AuthService {

    static isUserAuthenticated() {
        const user = StorageService.getItem(USER_AUTHENTICATED)
        return user && user.id;
    }

    static removeUserAuthenticated() {
        StorageService.removeItem(USER_AUTHENTICATED)
        StorageService.removeItem(USER_TYPE)
    }

    static enter(response) {
        StorageService.addItem(USER_AUTHENTICATED, response.data.data.key);
        if (response.data.data.userType == "arlug_client") {
            StorageService.addItem(USER_TYPE, 'arlug_client');
        } else if (response.data.data.userType == "client") {
            StorageService.addItem(USER_TYPE, response.data.data.userType);
        } else if (response.data.data.userType == "mgmt") {
            StorageService.addItem(USER_TYPE, response.data.data.userType);
        }

    }

    static getUserAuthenticated() {
        return StorageService.getItem(USER_AUTHENTICATED);
    }

}